import { Link } from "react-router-dom";
import Seo, { breadcrumbs } from "../components/Seo";
import { PROTECTION_PRODUCTS, PROTECTION_DISCLAIMER } from "../data/protectionProducts";

export default function ProtectionProductsHub() {
  return (
    <main id="main-content">
      <Seo
        title="Optional Vehicle Protection Products | Scott Sells Chevys"
        description="Explore optional vehicle protection products available through Scott Sells Chevys — service contracts, GAP, paint & fabric defense, tire & wheel, key replacement, and more."
        canonicalPath="/protection-products"
        jsonLd={[
          breadcrumbs([
            { name: "Home", path: "/" },
            { name: "Protection Products", path: "/protection-products" },
          ]),
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Optional Vehicle Protection Products",
            url: "https://scottsellschevys.com/protection-products",
          },
        ]}
      />

      <section className="ssc-hero">
        <div className="ssc-container py-10 md:py-16">
          <div className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-[var(--ssc-silver)]">Optional</div>
          <h1 className="ssc-display text-3xl md:text-5xl font-extrabold mt-2">Optional Vehicle Protection Products</h1>
          <p className="mt-4 text-[var(--ssc-silver)] max-w-3xl text-base md:text-lg leading-relaxed">
            Vehicle protection products can help protect your budget from certain unexpected repair costs,
            road hazards, key issues, appearance damage, and other ownership headaches. These products are
            optional, but they can be helpful depending on how long you plan to keep your vehicle, how much
            you drive, where you drive, and how much risk you want to carry yourself.
          </p>
        </div>
      </section>

      <section className="ssc-section">
        <div className="ssc-container">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="protection-hub-grid">
            {PROTECTION_PRODUCTS.map((p) => (
              <article
                key={p.slug}
                className="bg-white border border-[var(--ssc-line)] rounded-2xl p-5 flex flex-col"
                data-testid={`hub-card-${p.slug}`}
              >
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-12 h-12 rounded-xl bg-[var(--ssc-blue)]/10 text-[var(--ssc-blue)] grid place-items-center shrink-0">
                    <p.Icon size={24} />
                  </div>
                  <div>
                    <h2 className="text-lg font-extrabold text-[var(--ssc-navy)] leading-tight">{p.name}</h2>
                  </div>
                </div>
                <p className="text-sm text-[var(--ssc-ink)] mb-3 leading-relaxed">{p.shortDesc}</p>
                <div className="bg-[var(--ssc-paper)] rounded-xl p-3 mb-4">
                  <div className="text-[10px] font-bold uppercase tracking-widest text-[var(--ssc-ink-2)]">Best for</div>
                  <p className="text-xs text-[var(--ssc-ink)] mt-1 leading-snug">{p.bestFor}</p>
                </div>
                <div className="mt-auto flex flex-wrap gap-2">
                  <Link to={`/protection-products/${p.slug}`} className="ssc-btn ssc-btn-outline text-xs px-3 py-2"
                        data-testid={`hub-learn-${p.slug}`}>
                    Learn More
                  </Link>
                  <Link to={`/scotts-deal-desk?protection=${p.slug}`}
                        className="ssc-btn ssc-btn-primary text-xs px-3 py-2"
                        data-testid={`hub-add-${p.slug}`}>
                    Add to Build My Deal
                  </Link>
                </div>
              </article>
            ))}
          </div>

          <p className="text-xs text-[var(--ssc-ink-2)] mt-10 leading-relaxed max-w-3xl mx-auto text-center">
            {PROTECTION_DISCLAIMER}
          </p>
        </div>
      </section>
    </main>
  );
}
